import { useContext, useEffect, useState } from 'react'
import { useNavigate} from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/support-list'

import HistoryTable from '/components/support/table'
import Menu from '/components/support/nav-menu'
import { AppContext } from '/providers/app-context'
import {getSupportThreads} from '/providers/studio-api'
import { enqueueSnackbar } from 'notistack'

const SupportHistory = () => {

  const navigate = useNavigate()

  const { apiSource, apiKey } = useContext(AppContext)
  const [loading,setLoading] = useState(true) 
  const [threads,setThreads] = useState([]) 

  useEffect(() => {
    loadThreads()
  }, [])

  const loadThreads = async () => {
    const result = await getSupportThreads({apiSource,apiKey})
    setLoading(false)
    if (result.ok) setThreads(result.threads)
    else enqueueSnackbar({message:result.error?.message ?? result.error,variant:"error"})
  }

  const selectThread = thread_id => navigate(`../thread/${thread_id}`)

  return (
    <PageWrapper title="Signup" HelpText={HelpText} heading="Support History" menu={<Menu/>}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <HistoryTable loading={loading} threads={threads} selectThread={selectThread}/>
      </div>
    </PageWrapper>
  )
}

export default SupportHistory
